export default "__VITE_ASSET__02b1960a__"